import { createFileRoute } from '@tanstack/react-router';
import { EmptyState } from '@/components/page-header';
import { PayBillsForm } from '@/components/purchases/pay-bills-form';
import { useT } from '@/lib/i18n';
import { useOrgId } from '@/lib/org';

export const Route = createFileRoute('/expenses/pay-bills')({
  component: PayBills,
  validateSearch: (s: Record<string, unknown>): { billId?: string; contactId?: string } => ({
    ...(typeof s['billId'] === 'string' ? { billId: s['billId'] } : {}),
    ...(typeof s['contactId'] === 'string' ? { contactId: s['contactId'] } : {}),
  }),
});

function PayBills() {
  const t = useT();
  const orgId = useOrgId();
  const s = Route.useSearch();
  if (!orgId)
    return (
      <EmptyState
        title={t('shell.selectClient')}
        hint={t('purchasePages.listCommon.selectClientHint')}
      />
    );
  return <PayBillsForm key={orgId} {...s} />;
}
